import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			title: {
				fontSize: 20,
				fontWeight: 600,
				color: theme.palette.primary.contrastText,
				textAlign: "center",
				marginBottom: 20,
				marginTop: 10
			},
			subTitle: {
				fontWeight: 500,
				color: theme.palette.grey[50],
				textAlign: "center",
				fontSize: 15,
				marginTop: 10
			},
			driver: {
				borderTop: `1px dashed ${theme.palette.grey[800]}`,
				width: "100%"
			},
			rootItem: {
				padding: "12px 0px"
			},
			titleItem: {
				color: theme.palette.grey[50],
				fontSize: 14
			},
			price: {
				fontSize: 14,
				fontWeight: 500,
				color: theme.palette.primary.contrastText,
				textAlign: "end"
			},
			rootDiscount: {
				padding: 16,
				marginTop: 10,
				background: theme.palette.primary.main,
				borderRadius: 6
			},
			note: {
				fontStyle: "italic",
				fontSize: 14,
				color: theme.palette.success.main,
				padding: "16px 0px",
				textAlign: "center"
			},
			btnConfirm: {
				background: theme.palette.secondary.main,
				color: theme.palette.common.white,
				fontSize: 14,
				textTransform: "inherit",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: 36,
				width: "100%",
				borderRadius: 6,
				borderColor: theme.palette.grey["A100"],
				cursor: "pointer",
				"&:hover": {
					background: theme.palette.secondary.main,
					opacity: 0.7
				}
			},
			btnConfirmDisabled: {
				cursor: "auto !important",
				background: `${theme.palette.secondary.main} !important`
			},
			btnCancel: {
				background: theme.palette.grey["A100"],
				color: theme.palette.secondary.main,
				border: `1px solid ${theme.palette.secondary.main}`,
				fontSize: 14,
				textTransform: "inherit",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: 34,
				width: "100%",
				borderRadius: 6,
				cursor: "pointer",
				"&:hover": {
					background: theme.palette.secondary.main,
					opacity: 0.7
				}
			}
		}),
	{
		name: "ConfirmRewardDialog",
		index: 1
	}
);

export default useStyles;
